__turbopack_context__.v({
  "className": "jetbrains_mono_8d4609a4-module__kBTCMG__className",
});
